import { v4 as uuidv4 } from "uuid";
export class PACycleSaveModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.description = "";
        this.startDateAsString = "";
        this.endDateAsString = "";
        this.pmoTeamId = null;
        this.createdBy = uuidv4();
        this.reviews = [];
    }
}
export default class CycleSearch extends PACycleSaveModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
